var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card",style:(_vm.selfStyle)},[_c('div',{staticClass:"card-body"},[_vm._t("name",function(){return [_c('div',{staticClass:"card-header"},[_vm._v(" 置顶 ")])]}),_vm._l((_vm.datas),function(item){return _c('Stick',{key:item.id,attrs:{"item":item}})})],2),_c('Loading',{attrs:{"loading":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }